export default __webpack_public_path__ + "static/media/project_structure.95b2bd83.PNG";